import React, { FC, Fragment, useContext, useEffect } from 'react'
import { BasicStatsItem } from './index.styles';
import { Text } from '../text.component';
import { useTranslation } from 'react-i18next';
import { ExpandCard, NewTab } from '../../assets/icons';
import { IMediaMonitoringStat } from '../../interfaces/snp.interface';
import { CommentIcon, FacebookIcon, InstagramIcon, LikeIcon, ShareIcon, TGIcon, VKIcon, YTIcon } from '../../assets/icons/mm';
import ThemeContext, { Theme } from '../../contexts/theme.context';

interface IProps {
  list: IMediaMonitoringStat[];
  regionName: string;
}

const valueToIcon = {
  1: <InstagramIcon />,
  2: <FacebookIcon />,
  3: <VKIcon />,
  4: <YTIcon />,
  5: <TGIcon />
}

const MediaMonitoring: FC<IProps> = ({ list, regionName }) => {
  const { t } = useTranslation();
  const [sortedList, setSortedList] = React.useState<IMediaMonitoringStat[]>([]);
  const { theme } = useContext(ThemeContext)

  const handleLinkClick = () => {
    window.open(`https://mm.csi.kz/main?keyword=${regionName.split(' ')[0].toLowerCase()}&clientid=aqmola-ea&realm=aqmola-sic`, '_blank');
  }

  useEffect(() => {
    if (list) {
      setSortedList(list.sort((a, b) => b.likeSum - a.likeSum).slice(0, 3));
    }
  }, [list]);

  return (
    <BasicStatsItem id="mm">
      <div className="title with-icon">
        <div className="left">
          <Text color='var(--primary-color)' fontWeight={500} fontSize='0.875rem'>{t(`media-monitoring.title`)}</Text>
        </div>
        <div className="right">
          <span className='unit-container' >
            {/* {
              theme === Theme.LIGHT
                ? <Expand onClick={() => handleFullScreen({ isOpen: true, type: 'PSD' })} width={12} height={12} />
                : <ExpandWhite onClick={() => handleFullScreen({ isOpen: true, type: 'PSD' })} width={12} height={12} />
            } */}

            <ExpandCard onClick={() => handleLinkClick()} />
          </span>
        </div>
      </div>
      <div className="body monitoring-body">
        <Text fontSize='0.75rem' fontWeight={700} >
          {t(`media-monitoring.publications`)}
        </Text>
        <div data-tooltip={t(`media-monitoring.likes`)} data-tooltip-position="bottom">
          <LikeIcon />
        </div>
        <div data-tooltip={t(`media-monitoring.comments`)} data-tooltip-position="bottom">
          <CommentIcon />
        </div>
        <div data-tooltip={t(`media-monitoring.reposts`)} data-tooltip-position="bottom">
          <ShareIcon className='share-icon' />
        </div>


        {
          sortedList && sortedList.length > 0 && sortedList.map((item: IMediaMonitoringStat) => (
            <Fragment key={item.id}>
              <div className="text">
                {item.socialNet && valueToIcon[+item.socialNet as keyof typeof valueToIcon]}
                <a href={item.url} target='_blank' rel="noreferrer" color='var(--mm-link)'>{item.text}</a>
              </div>
              <Text fontSize='0.75rem' color='var(--primary-color)'>{item.likeSum || 0}</Text>
              <Text fontSize='0.75rem' color='var(--primary-color)'>{item.commentSum || 0}</Text>
              <Text fontSize='0.75rem' color='var(--primary-color)'>{item.sharedSum || 0}</Text>
            </Fragment>
          ))
        }
      </div>
    </BasicStatsItem>
  )
}

export default MediaMonitoring